import { useContext, useEffect } from 'react';
import AppContext from 'app/AppContext';
import { useWidgetContext } from 'widgets/WidgetContext';

export default function useWidgetStream() {
    const { widgetType, widgetKey } = useWidgetContext();

    const {
        services: { widgetStreamingService },
    } = useContext(AppContext);

    useEffect(() => {
        widgetStreamingService.register(widgetType, widgetKey);
        return () => widgetStreamingService.dispose(widgetType, widgetKey);
    }, [widgetType, widgetKey, widgetStreamingService]);

    const invokeRpcRequest = () => {
        widgetStreamingService.invokeRpcRequest(widgetType, widgetKey);
    };

    return { invokeRpcRequest };
}
